import React from 'react';
import { Zap, FileText, ChevronRight } from 'lucide-react';

interface ArrearSelectionViewProps {
  onSelect: (isAuto: boolean, isExp: boolean) => void;
}

export const ArrearSelectionView: React.FC<ArrearSelectionViewProps> = ({ onSelect }) => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-8 md:py-12 animate-fadeIn flex flex-col justify-center min-h-[calc(100vh-140px)]">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-3 tracking-tight">
          Arrear <span className="font-semibold text-orange-600">Calculation</span>
        </h2>
        <p className="text-gray-500 text-sm md:text-base max-w-md mx-auto">
          अपनी एरियर रिपोर्ट तैयार करने के लिए कोई एक तरीका चुनें।
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 max-w-3xl mx-auto w-full">
        {/* Automatic Arrear Card */}
        <div 
          onClick={() => onSelect(true, true)}
          className="group flex-1 bg-slate-900 rounded-[1.5rem] p-6 md:p-8 cursor-pointer hover:bg-slate-800 transition-all duration-300 flex flex-col items-center text-center border border-slate-800 shadow-lg hover:shadow-2xl hover:-translate-y-1"
        >
          <div className="w-14 h-14 bg-orange-500/10 text-orange-400 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-orange-500/20 transition-all duration-300">
            <Zap size={28} strokeWidth={1.5} />
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-white mb-2">Automatic</h3>
          <p className="text-slate-400 text-xs md:text-sm mb-6">इस विकल्प में आपको कोई भी गणना नहीं करनी है</p>
          
          <div className="mt-auto flex items-center text-orange-400 text-sm font-medium group-hover:translate-x-1 transition-transform">
            Start <ChevronRight size={16} className="ml-1" />
          </div>
        </div>

        {/* Manual Arrear Card */}
        <div 
          onClick={() => onSelect(false, false)}
          className="group flex-1 bg-blue-600 rounded-[1.5rem] p-6 md:p-8 cursor-pointer hover:bg-blue-700 hover:shadow-xl hover:shadow-blue-600/30 transition-all duration-300 flex flex-col items-center text-center border border-blue-500 hover:-translate-y-1"
        >
          <div className="w-14 h-14 bg-white/15 text-white rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-white/25 transition-all duration-300">
            <FileText size={28} strokeWidth={1.5} />
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-white mb-2">Manual</h3>
          <p className="text-blue-100 text-xs md:text-sm mb-6">इस विकल्प में आपको थोड़ी सी गणना की जानकारी होनी आवश्यक है</p>
          
          <div className="mt-auto flex items-center text-white text-sm font-medium group-hover:translate-x-1 transition-transform">
            Start <ChevronRight size={16} className="ml-1" />
          </div>
        </div>
      </div>
    </div>
  );
};
